module.exports = __webpack_public_path__ + "bd83ad8dd8236c0360ba1a12b9c221f6.png";